// extracted by mini-css-extract-plugin
module.exports = {"csr-G":"H_csr-G__uAYB9"};